import { SourceNode } from '@openhps/core';
import { SolidPropertyService } from './SolidPropertyService';
export class SolidPropertySource extends SourceNode {
    constructor(options) {
        super(options);
        this.once('ready', this.onBuild.bind(this));
    }
    onBuild() {
        return new Promise((resolve, reject) => {
            this.service = this.model.findService(SolidPropertyService);
            if (!this.service) {
                reject(new Error('No Solid session found'));
            }
            resolve();
        });
    }
    onPull(options) {
        throw new Error('Method not implemented.');
    }
}
//# sourceMappingURL=SolidPropertySource.js.map